import { FormEvent, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { Navigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { ThemeToggle } from "../components/theme-toggle";

export function SetPassword({ session, onComplete }: { session: Session | null; onComplete: () => void }) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [complete, setComplete] = useState(false);

  if (complete) return <Navigate to="/" replace />;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    if (password.length < 12) return setError("Use at least 12 characters.");
    if (password !== confirmPassword) return setError("The passwords do not match.");
    setBusy(true);
    const result = await supabase.auth.updateUser({ password });
    if (result.error) setError(result.error.message);
    else { onComplete(); setComplete(true); }
    setBusy(false);
  }

  return <main className="login-page"><ThemeToggle className="login-theme-toggle"/><section className="login-copy"><p className="eyebrow">Account setup</p><h1>Create your private<br/>staff password.</h1><p>This invitation is tied to your approved owner account.</p><div className="login-rule"><span>01</span> Use at least 12 characters</div><div className="login-rule"><span>02</span> Keep it unique to this console</div><div className="login-rule"><span>03</span> Store it in a password manager</div></section>
    <section className="login-panel"><form onSubmit={submit}><div className="brand dark"><span className="brand-mark">S</span><div><strong>Stockroom</strong><small>Operations console</small></div></div><div><p className="eyebrow">Owner invitation</p><h2>Set your password</h2><p>{session ? "Finish activating your staff account." : "Open the invitation link from your email to continue."}</p></div>
      <label>New password<input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} autoComplete="new-password" minLength={12} required disabled={!session}/></label>
      <label>Confirm password<input type="password" value={confirmPassword} onChange={(e)=>setConfirmPassword(e.target.value)} autoComplete="new-password" minLength={12} required disabled={!session}/></label>
      {error ? <p className="form-error" role="alert">{error}</p> : null}<button className="button primary wide" disabled={busy || !session}>{busy ? "Saving…" : "Activate account"}</button>
    </form></section></main>;
}
